<template>
  <v-container text-xs-left fill-height>
    <v-layout v-if="!hasInitializeError">
      <v-layout v-if="!isLoading" justify-center row wrap class="ma-1">
        <v-flex xs12 class="mb-4 text-center" v-if="target.displayed_style==='B'">
          <v-btn-toggle
            v-model="mode"
            mandatory
          >
            <v-btn :width="200" value="form">
              <v-icon class="mr-1">list_alt</v-icon>
              Webフォームで入力
            </v-btn>
            <v-btn :width="200" value="paper">
              <v-icon class="mr-1">description</v-icon>
              帳票を見て入力
            </v-btn>
          </v-btn-toggle>

          <v-sheet v-if="isConfirmed"
            color="#C8E6C9"
            class="mx-auto"
            width="100%">
            <h3 class="ma-2 pa-4">送信前に、内容をご確認ください。</h3>
          </v-sheet>

        </v-flex>
        <v-flex v-if="mode === 'form'" class="input-form">
          <template v-for="table in tables">
            <template v-if="!Array.isArray(table)">
              <v-img v-if="table.type === 'IMG'" :src="table.image" class="mb-1"
                     style="border: 1px solid black;" />
              <p v-if="table.type === 'TXT'" class="mb-1">{{ table.text }}</p>
            </template>
            <template v-else>
              <table class="mb-4">
                <tr v-for="formItem in table">
                  <td class="text-xs-center label">
                    <h3 v-if="formItem.display_subject">
                      {{ formItem.display_subject }}
                    </h3>
                    <h3 v-else="formItem.subject">{{ formItem.subject }}</h3>
                  </td>
                  <td class="input-field">
                    <label v-if="formItem.category" class="label required">
                        【{{ formItem.category }}】
                      </label>
                    <fragment v-for="fragment in formItem.fragments"
                              :fragment="fragment" :fragmentIdsIsActives="fragmentIdsIsActives"
                              :isConfirmed="isConfirmed"
                              @updateFragment="onUpdateFragment"
                              @updateFragmentIdsIsActives="updateFragmentIdsIsActives"/>
                  </td>
                </tr>
              </table>
            </template>
          </template>
        </v-flex>

        <v-flex v-else>
          <iframe id="paper-frame" :src="src" style="width: 100%; height: 100vh;"></iframe>
        </v-flex>

        <!--      <v-flex lg12 xs12  style="margin-bottom: 10px;">-->
        <!--        <v-card style="border: 1px solid black; padding: 10px; margin: 10px 0px; font-size: 18px;">-->
        <!--          <h4 class="card-title">-->
        <!--            添付ファイルを選択してください-->
        <!--          </h4>-->
        <!--          <input type="file" accept="image/*" @change="selectFiles" ref="fileSelector" multiple/>-->
        <!--          <v-btn v-show="isSelectedFile" @click="previewSelectFiles" color="info">-->
        <!--            <template v-if="isPreviewFile">閉じる</template>-->
        <!--            <template v-else>プレビュー</template>-->
        <!--          </v-btn>-->
        <!--          &lt;!&ndash;<v-btn v-show="isSelectedFile" @click="resetFileSelector">選択解除</v-btn>&ndash;&gt;-->
        <!--        </v-card>-->
        <!--        <template v-if="isPreviewFile">-->
        <!--          <v-card v-show="isSelectedFile" style="border: 1px solid black; padding: 10px; margin: 10px 0px; font-size: 18px;">-->
        <!--            <img v-for="dataURI in selectedFilesDataURI" :src="dataURI">-->
        <!--          </v-card>-->
        <!--        </template>-->
        <!--      </v-flex>-->

        <v-flex text-xs-center lg12 xs12 class="text-center">
          <v-btn
            class="white--text mr-10"
            color="blue lighten-2"
            large
            :loading="isSubmitting"
            :disabled="invalid || isSubmitting"
            v-show="isUsingTemporarySaving"
            @click="temporarilySave">
            一時保存
          </v-btn>

          <v-sheet
            v-show="isConfirmed"
            color="#fafafa"
            class="mx-auto"
            width="100%">
            <h3 class="mb-4 pa-4">上記の内容でよろしければ、「送信する」ボタンより送信してください。</h3>
          </v-sheet>

          <v-btn
            v-show="!isConfirmed"
            class="white--text ml-10"
            color="green lighten-2"
            large
            :disabled="invalid || (this.temporaryDocumentId && this.mode === 'form')"
            @click="transitionStateIsConfirmed">
            確認画面へ
          </v-btn>

          <v-btn
            v-show="isConfirmed"
            class="white--text ml-10"
            color="green lighten-2"
            large
            :loading="isSubmitting"
            :disabled="invalid || isSubmitting || (this.temporaryDocumentId && this.mode === 'form')"
            @click="transitionStateIsConfirmed">
            修正する
          </v-btn>

          <v-btn
            v-show="isConfirmed"
            class="white--text ml-10"
            color="green lighten-2"
            large
            :loading="isSubmitting"
            :disabled="invalid || isSubmitting || (this.temporaryDocumentId && this.mode === 'form')"
            @click="submit">
            送信する
          </v-btn>
        </v-flex>

  <!--      <v-snackbar-->
  <!--        :value="hasError"-->
  <!--        multi-line-->
  <!--        color="error"-->
  <!--        right-->
  <!--        :timeout="timeout"-->
  <!--        top-->
  <!--      >-->
  <!--        {{ this.$store.getters['error'] }}-->
  <!--        <v-btn-->
  <!--          color="white"-->
  <!--          text-->
  <!--          @click="snackbar = false"-->
  <!--        >-->
  <!--          Close-->
  <!--        </v-btn>-->
  <!--      </v-snackbar>-->
      </v-layout>

      <v-layout v-if="isLoading" justify-center align-center>
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-layout>
    </v-layout>
    <v-layout v-if="hasInitializeError" row wrap justify-center align-center>
      <h1>
        申し訳ありません。ただいまアクセスが混み合っております。<br/>
        しばらく時間をおいてから再度お試しください。
      </h1>
      <v-flex text-xs-center lg12 xs12 class="text-center">
        <v-btn
          class="white--text"
          color="green lighten-2"
          large
          :loading="isReloading"
          :disabled="isReloading"
          @click="reload">
          更新
        </v-btn>
      </v-flex>
    </v-layout>
      <temporary-save-url-mail-address-editor ref="TemporarySaveUrlMailAddressEditor"></temporary-save-url-mail-address-editor>
  </v-container>
</template>

<script>
import Fragment from '@/components/molecules/FormItemFragment'
import TemporarySaveUrlMailAddressEditor from '../components/molecules/TemporarySaveUrlMailAddressEditor'
import {
  FormItem,
  FormItemFragment,
  UserInput,
  Target,
  Description
} from '@/model/models'
import { uuid } from '@/services'
import Vue from "vue";

export default {
  name: 'Survey',
  components: {
    Fragment,
    TemporarySaveUrlMailAddressEditor
  },
  props: {
    sheetId: String,
    temporaryDocumentId: String
  },
  data () {
    return {
      selectedFilesDataURI: [],
      timeout: 7000,
      isLoading: false,
      isSubmitting: false,
      isPreview: false,
      isReloading: false,
      byteLimit: 10 * 1024 ** 1024,
      mode: 'form',
      token: 'MStGK9kRknUfES4tzlmBbYohHHBe9e27UPrWpoY75x1Wpadt3BOxmHSTXKo%2B%2B8FWP0K9vnHrrxacW1o7WPnHU0QVZIpvPqxZN1lJdN36R6E3pmYeo7gPrVhmAVYTlmfBSpCp%2B%2FyTh4E7AmDzTlLlptggRiIjJAK8d61nj1fZI6PsrMoFVZTc4IHVhlhwTmP7KGFFCtYPtaVWX3Z9JruCpIZ%2FNGySyv7s9ZXZirFkS7dVVUP%2F9%2B7d7%2FBMuWPy2TGC7ltc1de5e5omzVYvkPyK1HJFWJ8FJFUvTQ3hRUut0w08nY9SOeQBGJ%2FlSWcQwsMP6Q1wprzNOeSqALy5D1ALIH5Ljwt7%2FYUVlR07M99mSTVOfSF3bsgHy%2BcYRNYra5vsXcnRrLz6cjzNIt%2BWpt9DKuJHH%2FymI4HIQZExe%2FdtAzKaVqSAzOPJLyEjPJ%2FOCGg5s9MeeS%2BVRh0chEcHboMIxrZcXymcUes33chEE0jhBSUXCnyvcA9AAM48d2Q5xLtD2IyqBcIVCgF0Q1LSJagSREpPdr6dH5pR7FWYi%2B4%2FAK6qDrIN1Dbbz58jJliwyNGUJ253Uy8xfOmmioYpe4ewl%2BSPZxmE5CC3rgTxqU6UB4U9Vtd9%2Frr96LekN6Z6gdSmQbv2Mx1VApUXuMYVNnP4SnshSlviFgf4xdjLgRJazC4LPbTM43Qvd4UIW9Ad7RkMS8nFqZb6Gv6ThfKvhgiXEipp9ClRwFTDvwUu1f0%2B%2FW%2FRcBKDsocSujboJ56w%2F4ihVEE%3D',
      isQuit: false,
      issuedTemporaryDocumentId: '',
      fragmentIdsIsActives: {},
      isConfirmed: false,
    }
  },
  computed: {
    formItems () {
      return FormItem.query().withAllRecursive().orderBy('sequence').get()
    },
    fragments () {
      return FormItemFragment.query().withAllRecursive().get()
    },
    fragmentInputs () {
      return UserInput.query().withAllRecursive().get()
    },
    target () {
      let target = Target.query().first()
      if (['B', 'F'].includes(target.displayed_style)) {
        this.mode = 'form'
      } else {
        this.mode = 'paper'
      }
      return target
    },
    invalid () {
      return FormItemFragment.query()
        .where('required', true)
        .where((_record, query) => {
          query.where('value', null).orWhere('value', '')
            .orWhere('value', value => {
              if (value) { return value.length === 0 }
            })
        })
        .count() > 0
    },
    isSelectedFile () {
      return this.selectedFilesDataURI.length !== 0
    },
    isPreviewFile () {
      return this.isPreview
    },
    hasInitializeError () {
      return this.$store.getters['initializeError'] !== null
    },
    hasError () {
      return this.$store.getters['error'] !== null
    },
    src () {
      let temporaryDocumentIdQueryParameter = ''
      if (this.temporaryDocumentId) {
        temporaryDocumentIdQueryParameter = `&temporary-document-id=${this.temporaryDocumentId}`
      }
      return `${process.env.VUE_APP_PAPER_URL}/${this.sheetId}/?viewable-document=true&editable-document=true&viewable-staff-checking=true&editable-staff-checking=true&token=${this.token}${temporaryDocumentIdQueryParameter}`
    },
    descriptions () {
      return Description.query().orderBy('sequence').get()
    },
    tables () {
      let targetEntities = [...this.formItems, ...this.descriptions]
      targetEntities.sort(function (a, b) {
        if (a.sequence < b.sequence) return -1

        if (a.sequence > b.sequence) return 1

        return 0
      })

      let tables = []
      let table = []
      for (let targetEntity of targetEntities) {
        if (targetEntity['_class'] === 'Description') {
          if (table.length > 0) {
            tables.push(table)
            table = []
          }
          tables.push(targetEntity)
        } else {
          table.push(targetEntity)
        }
      }

      if (table.length > 0) {
        tables.push(table)
      }

      return tables
    },
    gaTrackingId () {
      return this.target['ga_tracking_id']
    },
    isUsingTemporarySaving () {
      return this.target['is_using_temporary_saving'] && this.mode === 'paper'
    }
  },
  methods: {
    onUpdateFragment (updatedFragment) {
      const {id, form_item, updatedValue} = updatedFragment

      FormItemFragment.update({
        where: id,
        data: {
          value: updatedValue
        }
      })

      // FragmentInput.insert({
      //   data: {
      //     form_item: form_item,
      //     fragment: id,
      //     value: updatedValue,
      //     x: 0,
      //     y: 0,
      //     height: 0,
      //     width: 0,
      //   }
      // })
    },
    getCookie (key) {
      const cookies = document.cookie.split(';')
      let target = cookies.filter(x => key === x.split('=')[0].trim())[0]
      return target.split('=')[1]
    },
    getBytes (str) {
      return (encodeURIComponent(str).replace(/%../g, 'x').length)
    },
    sum (list) {
      return list.reduce((x, y) => x + y)
    },
    descendingOrderBytes (dataURIs) {
      return dataURIs.sort((a, b) => a.byte < b.byte ? 1 : -1)
    },
    divideDataURIsUnderByteLimit (dataURIs) {
      const sortedDataURIs = this.descendingOrderBytes(dataURIs)
      const max = sortedDataURIs.shift()
      let diff = this.byteLimit - max.byte
      const cand = this.descendingOrderBytes(sortedDataURIs.filter(x => x.byte < diff))

      const addDataURIs = cand.filter(x => {
        const judge = (diff - x.byte > 0)
        if (judge) diff -= x.byte
        return judge
      })
      return [max, ...addDataURIs]
    },
    receiveMessage (event) {
      if ('object' === typeof(event.data) && 'function' in event.data) {
        if (![200, 201].includes(event.data.statusCode)) {
          const options = {
            action: {
              text :'close',
              onClick: (e, toast) => {
                 toast.goAway(0)
               }
            }
          }
          let message = "エラーが発生しました。更新してもう一度やり直してください。"
          if ('message' in event.data) {
            message = event.data.message
          }
          Vue.toasted.error(message, options)

          this.isSubmitting = false
          return
        }
        if (this.isQuit) {
          this.$router.push(`/complete/${this.sheetId}/`)
        } else {
          this.$toasted.success('保存しました。', {
            theme: 'toasted-primary',
            position: "top-right",
            duration: 5000
          })
        }
        this.isSubmitting = false
      }
    },
    transitionStateIsConfirmed () {
      /**
       * 確認画面と入力画面を切り替える
       * - フォームを活性・非活性にする
       * - ページの一番上までスクロールする
       */
      this.toggleIsConfirmed()
      this.scrollToTop()
    },
    toggleIsConfirmed () {
      /**
       * フォームを活性・非活性にする
       */
      this.isConfirmed = !this.isConfirmed
    },
    scrollToTop () {
      /**
       * ページの一番上までスクロールする
       * @property {behavior} 動きの種類
       */
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    async submit () {
      if (this.invalid) return

      this.isSubmitting = true
      this.isQuit = true
      if (this.mode === 'paper') {
        const focusIframe = document.getElementById('paper-frame').contentWindow
        await focusIframe.postMessage({
          'function': 'form',
          'event': 'save',
        }, '*')
        return
      }

      // 添付ファイルのサイズチェック
      const selectedFilesDataURI = this.selectedFilesDataURI
      const total = selectedFilesDataURI.length
      let dataURIs = selectedFilesDataURI.map(x => {
        return {
          'uri': x,
          'byte': this.getBytes(x)
        }
      })
      const isSizeOver = dataURIs.filter(x => this.byteLimit <= x.byte).length !== 0
      if (isSizeOver) {
        window.alert('ファイルサイズが大きすぎます')
        this.isSubmitting = false
        return
      }

      //demandの送信 => demand_idを取得
      const sheetId = this.$route.params.sheetId
      let demand = {}
      demand['sheet'] = sheetId
      demand['channel'] = 'W'
      demand['comment'] = ''
      demand['status'] = 'U'
      demand['request_id'] = uuid()
      if (this.$route.params.accessToken) {
        demand['access_token'] = this.$route.params.accessToken
      }

      let fragmentInputs = []
      for (let fragment of this.fragments) {
        let registeringFragmentInput = {}
        registeringFragmentInput['form_item'] = fragment.form_item
        registeringFragmentInput['fragment'] = fragment.id
        if (Array.isArray(fragment.value)) {
          if (fragment.value.length === 0) {
            registeringFragmentInput['value'] = null
          } else {
            registeringFragmentInput['value'] = fragment.value.join(',')
          }
        } else {
          registeringFragmentInput['value'] = fragment.value
        }
        fragmentInputs.push(registeringFragmentInput)
      }
      demand['user_inputs'] = fragmentInputs

      const config = {
        headers: {
          'content-type': 'application/json'
        }
      }
      let registeredDemand = await this.$store.dispatch('saveDocument', demand, config)

      if(this.hasError) {
        this.isSubmitting = false
        return
      }

      // 添付ファイルのアップロード
      if (total > 0) {
        const sumByteNum = this.sum(dataURIs.map(x => x.byte))
        let reqDataURIs = []

        if (this.byteLimit <= sumByteNum) {
          let cnt = 0 // 念の為、無限ループを防ぐためのカウンタ
          while (dataURIs.length !== 0) {
            const divided = this.divideDataURIsUnderByteLimit(dataURIs)
            reqDataURIs.push(divided)
            dataURIs = dataURIs.filter(x => !divided.includes(x))
            cnt++
            if (100 < cnt) break  // 100回以上ループすることは、まずあり得ない
          }
        } else {
          reqDataURIs.push(dataURIs)
        }
        console.log(reqDataURIs)
        for (let r of reqDataURIs) {
          const params = {
            data_uris: r.map(x => x.uri)
          }
          await this.$store.dispatch('uploadAttachedFiles',
            {
              params,
              demandId,
              config
            }
          )
        }
      }

      this.$router.push(`/complete/${this.sheetId}/`)

      this.isSubmitting = false
    },
    async temporarilySave () {
      const origin = new URL(window.location.href).origin
      const editResult = await this.$refs.TemporarySaveUrlMailAddressEditor.open(`${origin}/temporary-document/${this.getTemporaryDocumentId()}`)
      if (editResult.isCancel) {
        return
      }
      this.isQuit = editResult.isQuit
      const focusIframe = document.getElementById('paper-frame').contentWindow
      await focusIframe.postMessage({
        'function': 'form',
        'event': 'temporarilySave',
        'targetId': this.target.id,
        'temporaryDocumentId': this.getTemporaryDocumentId(),
        'mailAddresses': editResult.mailAddresses,
      }, '*')
    },
    onBeforeunloadHandler (event) {
      event.returnValue = ''
    },
    selectFiles: function (event) {
      event.preventDefault()
      this.selectedFilesDataURI = []
      const selectedFiles = event.target.files
      let dataURIs = []

      for (let file of selectedFiles) {
        const reader = new FileReader()
        reader.onload = function (event) {
          window.e = event
          const dataURI = event.target.result
          dataURIs.push(dataURI)
          this.selectedFilesDataURI = dataURIs
        }
        reader.readAsDataURL(file)
      }

      this.selectedFilesDataURI = dataURIs
    },
    previewSelectFiles: function (event) {
      event.preventDefault()
      this.isPreview = !this.isPreview
    },
    resetFileSelector: function (event) {
      event.preventDefault()
      const input = this.$refs.fileSelector
      input.type = 'text'
      input.type = 'file'
      this.selectedFilesDataURI = []
    },
    reload () {
      this.isReloading = true
      location.reload()
    },
    getTemporaryDocumentId () {
      if (!this.temporaryDocumentId) {
        if (!this.issuedTemporaryDocumentId) {
          this.issuedTemporaryDocumentId = uuid()
        }
        return this.issuedTemporaryDocumentId
      } else {
        return this.temporaryDocumentId
      }
    },
    InitializeFragmentIdsIsActives () {
      this.fragmentIdsIsActives = {}
      for (const fragment of this.fragments) {
        this.fragmentIdsIsActives[fragment.id] = true
      }
    },
    updateFragmentIdsIsActives (fragmentId, isActive) {
      this.fragmentIdsIsActives[fragmentId] = isActive
    }
  },
  async created () {
    window.addEventListener('beforeunload', this.onBeforeunloadHandler, false)

    this.isLoading = true

    // await this.$store.dispatch('fetchAuthenticatedUser')

    // const userContext = this.$store.getters['userContext']
    // const organization = userContext['organization']

    await this.$store.dispatch('initialize', this.sheetId)
    await this.$store.dispatch('fetchTargets', this.sheetId)

    // 回答をし直す時
    let fragments = FormItemFragment.query().get()

    let userInputs = []
    for (let fragment of fragments) {
      let value = null

      if (fragment.type === 'CK') {
        value = []
      }

      const userInput = {
        'id': uuid(),
        'form_item': fragment.form_item,
        'fragment': fragment.id,
        'value': value
      }

      userInputs.push(userInput)

      UserInput.create({
        data: userInput
      })
    }

    // FragmentInput.create({
    //   data: fragmentInputs
    // })

    gtag('config', this.gaTrackingId, { 'page_path': this.$route.path })

    this.InitializeFragmentIdsIsActives()

    this.isLoading = false
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.onBeforeunloadHandler, false)
  },
  mounted () {
    window.addEventListener('message', this.receiveMessage, false)
    this.$root.TemporarySaveUrlMailAddressEditor = this.$refs.TemporarySaveUrlMailAddressEditor
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
  padding: 10px;
}

th, td {
  border: solid 1px;
}

td.label {
  background-color: #F0F2F3;
  padding: 10px;
}

td.input-field {
  padding: 10px 10px;
}

.input-form {
  margin-bottom: 10px;
}
</style>

<style>
.v-list-item {
  padding: 0 5px;
}

.v-list-item__title {
  font-size: 0.7rem;
}
</style>
